import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Paper, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import { deleteAddressRequest } from './../../../../../redux/actions/AddressesActions';

import AddressInfo from './AddressInfo';
import AddressButtons from './AddressButtons';
import DeleteDialog from './DeleteDialog';

import {
  createAddressLineText,
  getLocationTextByCountry,
} from './../../../../../helpers/addresses/AddressesHelper';

const useStyles = makeStyles((theme) => ({
  container: {
    border: (props) =>
      props.main === 'true'
        ? `1px solid ${theme.palette.primary.main}`
        : `1px solid #BCBCBC`,
    height: '100%',
    borderRadius: 10,
  },
}));

const Address = ({ ...props }) => {
  const { address, onClickEdit, regions } = props;
  const { primary, nickName, addressType } = address;
  const dispatch = useDispatch();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleDeleteClick = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleDialogDelete = async () => {
    setIsLoading(true);
    const response = await dispatch(
      deleteAddressRequest(
        nickName,
        primary,
        addressType === 'Billing' ? true : false,
      ),
    );
    if (!response) setIsLoading(false);
  };

  const handleEditClick = () => {
    onClickEdit(address);
  };

  const classes = useStyles({ main: primary });
  return (
    <Paper elevation={0} className={classes.container}>
      <Box display="flex" flexDirection="row" height="100%">
        <AddressInfo
          title={nickName}
          addressText={createAddressLineText(address)}
          locationText={getLocationTextByCountry(address, regions)}
          primary={primary}
        />
        <AddressButtons
          main={primary}
          onClick={handleDeleteClick}
          onClickEdit={handleEditClick}
          disabled={address.isMainCommerce}
        />
      </Box>
      <DeleteDialog
        open={dialogOpen}
        name={nickName}
        isLoading={isLoading}
        onClick={handleCloseDialog}
        onClickDelete={handleDialogDelete}
      />
    </Paper>
  );
};

Address.propTypes = {
  address: PropTypes.object,
  onClickEdit: PropTypes.func,
  regions: PropTypes.array,
};

export default Address;
